const updates = {
  tittle: `Actualizaciones Recarga-te.`,
  date: `25/01/2023`,
  descriptions: [
    `Este documento tiene el fin de explicar y ejemplificar los añadidos y actualizaciones  al sistema web de recarga-te, dichos cambios estarán presentes a partir del 25 de octubre del año en curso.`,
    `A continuación se listaran las secciones del sistema donde se presentan los cambios:`,
  ],
  sections:[
    {
      tittle: `Usuarios.`,
      children: [
        {
          description: `Se agregó un botón para seleccionar qué usuarios pueden ver los montos de las recargas.`,
          image: `usuarios1.png`
        }
      ]
    },
    {
      tittle: `Recargas masivas.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`,
          image: `masivas1.png`
        },
        {
          description: `Se añadieron etiquetas al momento de pasar el cursor sobre el botón.`,
        },
        {
          description: `Se actualizó la pantalla del detalle.`,
          image: `masivas3.png`
        },
        {
          description: `Se actualizó la ventana para programar las recargas.`,
          image: `masivas2.png`
        }
      ]
    },
    {
      tittle: `Portabilidades.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`,
          image: `portas2.png`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,

        },
        {
          description: `Se actualizaron los filtros, ahora se puede agregar más de un filtro para una mejor visualización de los datos.`,

        },
        {
          description: `Se actualizaron los botones para seleccionar las fechas, ahora solo basta con hacer click en la etiqueta para abrir el selector de fechas.`,
          image: `portas1.png`
        },
        {
          description: `Se eliminó el botón de consultar, ahora basta con seleccionar las dos fechas para que el sistema haga la búsqueda en automático.`,

        }
      ]
    },
    {
      tittle: `Inventario.`,
      children: [
        {
          description: `Se actualizaron los botones e iconos.`,
          image: `inventario1.png`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,

        },
        {
          description: `Se actualizaron los botones para seleccionar las fechas, ahora solo basta con hacer click en la etiqueta para abrir el selector de fechas.`,

        },
        {
          description: `Se eliminó el botón de consultar, ahora basta con seleccionar las dos  fechas para que el sistema haga la búsqueda en automático.`
        },
        {
          description: `Se actualizaron los filtros, ahora se puede agregar más de un filtro para una mejor visualización de los datos.`
        },
        {
          description: `Se agregó un filtro por monto.`,

        },
        {
          description: `Se agregó un indicador para saber de que usuario estamos viendo el inventario.`,
          image: `inventario2.png`
        },
      ]
    },
    {
      tittle: `Recargas por carrier.`,
      children: [
        {
          description: `Se agregaron dos carriers (Bait y Virgin).`,
          image: `carrier1.png`
        },

      ]
    }
  ]
}


module.exports = {
  updates
}